import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { rankingData, rankingTabs } from "@/mocks/home";

export default function Ranking() {
  const [activeTab, setActiveTab] = useState(rankingTabs[0].id);
  const items = rankingData[activeTab] ?? [];

  return (
    <section id="ranking" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <SectionHeading
              kicker="Trending Leads"
              title="线索热度榜单"
              description="按投稿量与核验进度综合排序，帮助您了解近期较受关注的匿名投稿渠道方向。仅供趋势参考，不代表任何具体结论。"
            />
          </Reveal>

          <Reveal delay={80}>
            <div className="inline-flex items-center gap-1 rounded-full border border-background-200/70 bg-background-100 p-1">
              {rankingTabs.map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 font-label text-sm transition-colors cursor-pointer ${
                    activeTab === tab.id
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-primary-600"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={120}>
          <ol className="mt-12 divide-y divide-background-200/70 border-y border-background-200/70 md:mt-16">
            {items.map((item) => (
              <li
                key={`${activeTab}-${item.rank}`}
                className="group flex flex-col gap-4 py-7 transition-colors hover:bg-background-100/70 md:flex-row md:items-center md:gap-8 md:px-4"
              >
                <span className="font-heading text-4xl leading-none text-accent-500 md:w-20 md:text-5xl">
                  {String(item.rank).padStart(2, "0")}
                </span>

                <div className="flex flex-1 flex-col gap-2 md:flex-row md:items-center md:justify-between md:gap-8">
                  <div className="md:max-w-2xl">
                    <div className="flex flex-wrap items-center gap-3">
                      <h3 className="font-heading text-lg text-foreground-950 md:text-xl">
                        {item.title}
                      </h3>
                      <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                        {item.tag}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {item.summary}
                    </p>
                  </div>

                  <div className="flex items-center gap-8 md:shrink-0 md:flex-col md:items-end md:gap-2">
                    <span className="font-label text-sm text-foreground-800">热度 {item.heat}</span>
                    <span className="flex items-center gap-1 font-label text-xs text-primary-600">
                      <i className="ri-arrow-up-line" />
                      {item.delta}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}